import { EMPTY_FUNCTION, EMPTY_LIST } from '../../../../constants/common'
import { RequestProfileHeaderFooterAddNewText } from '../RequestProfileHeaderFooterAddNewText'
import { RequestProfileHeaderFooterMoreButton } from '../RequestProfileHeaderFooterMoreButton'

import * as styles from './RequestProfileHeaderFooterHiddenMeasureLayer.module.css'

function RequestProfileHeaderFooterHiddenMeasureLayer({
  addNewTextMeasureRef,
  moreButtonMeasureRef,
}) {
  return (
    <>
      <div
        aria-hidden
        className={styles.measureLayer}
        ref={addNewTextMeasureRef}
      >
        <RequestProfileHeaderFooterAddNewText />
      </div>
      <div
        aria-hidden
        className={styles.measureLayer}
        ref={moreButtonMeasureRef}
      >
        <RequestProfileHeaderFooterMoreButton
          blocked
          buttonClassName={styles.measureButton}
          options={EMPTY_LIST}
          onSelectItem={EMPTY_FUNCTION}
        />
      </div>
    </>
  )
}

export default RequestProfileHeaderFooterHiddenMeasureLayer
